"use client"

import { useEffect, useRef, useState } from 'react';
import AuthLogo from '../auth-logo'
import axios from 'axios';
import Cookies from 'js-cookie';
import { useTranslations } from 'next-intl';

export default function ResetPasswordView() {

  const t = useTranslations("resetPassword")
  const [hasGivenEmail, setHasGivenEmail] = useState(false)
  const [emailInput, setEmailInput] = useState("")
  const [token, setToken] = useState<string>()
  const [password,setPassword] = useState<string>()
  const [errorMessage,setErrorMessage] = useState<string>()

  useEffect(() => {

    interface Keyboards {
      backspace: number;
      arrowLeft: number;
      arrowRight: number;
    }

    const inputsContainer = document.querySelector('.d-flex.mb-7') as HTMLElement;
    if (!inputsContainer) {
      console.error('Inputs container not found');
      return;
    }

    const inputs = inputsContainer.querySelectorAll('input') as NodeListOf<HTMLInputElement>;

    const KEYBOARDS: Keyboards = {
      backspace: 8,
      arrowLeft: 37,
      arrowRight: 39,
    };

    function handleInput(e: Event): void {
      const input = e.target as HTMLInputElement;
      const nextInput = input.nextElementSibling as HTMLInputElement | null;
      if (nextInput && input.value) {
        nextInput.focus();
        if (nextInput.value) {
          nextInput.select();
        }
      }
    }

    function handlePaste(e: ClipboardEvent): void {
      e.preventDefault();
      const paste = e.clipboardData?.getData('text') || '';
      inputs.forEach((input, i) => {
        input.value = paste[i] || '';
      });
    }

    function handleBackspace(e: KeyboardEvent): void {
      const input = e.target as HTMLInputElement;
      if (input.value) {
        input.value = '';
        return;
      }

      const previousInput = input.previousElementSibling as HTMLInputElement | null;
      if (previousInput) {
        previousInput.focus();
      }
    }

    function handleArrowLeft(e: KeyboardEvent): void {
      const previousInput = (e.target as HTMLInputElement).previousElementSibling as HTMLInputElement | null;
      if (!previousInput) return;
      previousInput.focus();
    }

    function handleArrowRight(e: KeyboardEvent): void {
      const nextInput = (e.target as HTMLInputElement).nextElementSibling as HTMLInputElement | null;
      if (!nextInput) return;
      nextInput.focus();
    }

    inputs[0].addEventListener('paste', handlePaste);

    inputs.forEach(input => {
      input.addEventListener('input', handleInput);

      input.addEventListener('focus', e => {
        setTimeout(() => {
          (e.target as HTMLInputElement).select();
        }, 0);
      });

      input.addEventListener('keydown', e => {
        switch (e.keyCode) {
          case KEYBOARDS.backspace:
            handleBackspace(e);
            break;
          case KEYBOARDS.arrowLeft:
            handleArrowLeft(e);
            break;
          case KEYBOARDS.arrowRight:
            handleArrowRight(e);
            break;
          default:
        }
      });
    });

  })

  const getCode = (): string => {
    let codeInputs = document.getElementsByClassName("form-control")
    let listCodeInputs = Array.from(codeInputs);
    let code = ""
    for (const inputEl of listCodeInputs) {
      const input: HTMLInputElement = inputEl as HTMLInputElement
      code = code + `${input.value}`
    }
    return code
  }

  const validerCode = async () => {
    const url = "https://vexub.fr/api/vexub_v2/compte/motdepasseoublier_verifcode.php"
    const code = getCode()
    const email = emailInput

    const formData = new FormData()
    formData.append("email", email)
    formData.append("secretcode", code)

    const resp = await axios.post(url, formData)
    if (resp.data.status == "success") {
      setToken(resp.data.token)
    }
  }

  const sendEmail = async () => {
    const inputEmail = emailInput
    const formData = new FormData()

    formData.append("email", inputEmail)
    const url = "https://vexub.fr/api/vexub_v2/compte/mdpoublier.php"

    let requestResetPassword = await axios.post(url, formData)
    let responseData: string = requestResetPassword.data
    if (responseData.includes("success")) {
      setHasGivenEmail(true)
    }
  }

  function encryptToMD5(input : string) {
    const hexDigits = '0123456789abcdef';
    let result = '';

    for (let i = 0; i < input.length; i++) {
      const char = input.charCodeAt(i);
      result += hexDigits.charAt((char >> 4) & 0x0f) + hexDigits.charAt(char & 0x0f);
    }

    return result;
  }

  function setCookie(name: any, value: any, days: any) {
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
  
  
    // document.cookie = `${name}=${value};${expires};path=/;Secure;SameSite=Strict`;
    Cookies.set(name, value, { 
      expires: 7, // Expire dans 7 jours
      path: '/', // Disponible sur l'ensemble du site
      secure: false, // Utilisé uniquement sur les connexions HTTPS
      sameSite: 'Strict' // Protéger contre les attaques CSRF
    });  
  }

  const validNewPassword = async() => {
    setErrorMessage(undefined)
    const url = "https://vexub.fr/api/vexub_v2/compte/validernvmdp.php"
    const formData = new FormData()

    if (password == undefined || password == "" || password.length < 8){
      setErrorMessage(t("mdpError"))
      return
    }

    const encryptPassword = encryptToMD5(password)
    

    formData.append("token", token!)
    formData.append("mdp",encryptPassword)
    
    let responseRequest = await axios.post(url,formData)
    let responseMessage : string = responseRequest.data
    if (responseMessage.includes("success")){
      setCookie('token', token, 7);
      setCookie('email', emailInput, 7);
      window.location.href = "/app";
    }
  }

  return (
    <>
      {/* Page header */}
      <div className="max-w-3xl mx-auto text-center pb-12">
        {/* Logo */}
        <AuthLogo />
        {/* Page title */}
        <h1 className="h2 bg-clip-text text-transparent bg-gradient-to-r from-slate-200/60 via-slate-200 to-slate-200/60">{t("title1")}</h1>
      </div>

      {/* Form */}
      <div hidden={token != undefined} className="max-w-sm mx-auto">

        {
          !hasGivenEmail ?
            <>
              <form>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm text-slate-300 font-medium mb-1" htmlFor="email">{t("Email")}</label>
                    <input onChange={(e) => { setEmailInput(e.currentTarget.value) }} id="email" className="form-input w-full" type="email" required />
                  </div>
                </div>
                <div className="mt-6">
                  <button className="btn text-sm text-white bg-purple-500 hover:bg-purple-600 w-full shadow-sm group" onClick={(e) => { e.preventDefault(); sendEmail() }}>
                    {t("ButtonTitle")} <span className="tracking-normal text-purple-300 group-hover:translate-x-0.5 transition-transform duration-150 ease-in-out ml-1">-&gt;</span>
                  </button>
                </div>
                <div className="text-sm text-slate-400 mt-5">
                  {t("goBackText")} <a className="font-medium text-purple-500 hover:text-purple-400 transition duration-150 ease-in-out" href="/signin">{t("LoginButton")}</a>
                </div>

              </form>
            </>
            :
            <>
              <div>
                <h2 style={{ fontFamily: "var(--font-inter)", fontWeight: 'bold', marginBottom: '10px', textAlign: 'center' }}>
                  {t("CodeTitle1")}
                </h2>
                <h2 style={{ color: '#cbcbcb', fontFamily: 'sans-serif', fontSize: '0.9em', marginBottom: '25px', textAlign: 'center' }}>
                  {t("VerifySpam")}
                </h2>
              </div>

              <div className="d-flex mb-7" style={{ display: 'flex', maxWidth: "24em", marginLeft: "auto", marginRight: "auto" }}>
                {[...Array(6)].map((_, i) => (
                  <input key={i} className="form-control" maxLength={1} pattern="[0-9]" style={{ borderRadius: '20px', color: '#000', display: 'block', fontSize: '1.25rem', height: '65px', marginRight: '0.5rem', minWidth: '0', textAlign: 'center' }} type="tel" />
                ))}
              </div>

              <div className="d-flex mb-7" style={{ maxWidth: "24em", marginLeft: "auto", marginRight: "auto" }}>
                <div className="btn text-sm text-white bg-purple-500 hover:bg-purple-600 w-full shadow-sm group" id="valider_btn" style={{ cursor: 'pointer', marginTop: '50px' }} onClick={() => validerCode()}>
                 { t("Valider")}
                  <span className="tracking-normal text-purple-300 group-hover:translate-x-0.5 transition-transform duration-150 ease-in-out ml-1">{`->`}</span>
                </div>
              </div>
            </>
        }


      </div>
      <div hidden={token == undefined} className="max-w-sm mx-auto">
        <form>
          <div className="space-y-4">
            <div>
              <label className="block text-sm text-slate-300 font-medium mb-1" htmlFor="password">{t("NewMdpTitle")} <span className="text-rose-500">*</span></label>
              <input onChange={(e) => {setPassword(e.currentTarget.value)}} id="input_login_mdp" className="form-input w-full" type="password" autoComplete="on" required />
            </div>
          </div>
          <div className="mt-6 flex flex-col gap-2">
            <div className="btn text-sm text-white bg-purple-500 hover:bg-purple-600 w-full shadow-sm group" id="continue_btn" onClick={() => {validNewPassword()}} style={{ cursor: 'pointer' }}>
              {t("ButtonTitle")} <span className="tracking-normal text-purple-300 group-hover:translate-x-0.5 transition-transform duration-150 ease-in-out ml-1">-&gt;</span>
            </div>
            <p hidden={errorMessage == undefined} className=' text-red-700 text-center'>
              {errorMessage}
            </p>
          </div>
        </form>
      </div>
    </>
  )
}
